<p-drawer [visible]="visible" (visibleChange)="fechar()" position="right"
  [style]="{ width: '560px', maxWidth: '100vw' }" [modal]="true" [dismissible]="true">
  <ng-template #header>
    <div class="drawer-header-content">
      <div class="header-titles">
        <h2>
          @if (modo === 'retificar') {
          Corrigir factura {{ documentoOriginal?.documentNo || 'FT' }}
          } @else {
          Emitir Factura
          }
        </h2>
        <p class="subtitle">Preencha os dados para gerar a factura e a referência Multicaixa.</p>
      </div>
    </div>
  </ng-template>

  <form [formGroup]="form" class="drawer-body">
    <!-- SECÇÃO 1: CLIENTE & POSTO -->
    <section class="form-section">
      <div class="section-header">
        <h3>CLIENTE &amp; POSTO</h3>
        <span class="required-badge">Obrigatório</span>
      </div>

      <div class="form-group">
        <label for="drawerCliente">Cliente *</label>
        <p-select id="drawerCliente" formControlName="idCliente" [options]="clientes" optionLabel="nome"
          optionValue="id" placeholder="Selecione o cliente" [filter]="true" filterBy="nome,nif" appendTo="body"
          [style]="{ width: '100%' }" />
      </div>

      <div class="form-group">
        <label for="drawerPosto">Posto</label>
        <input id="drawerPosto" type="text" pInputText formControlName="postoDesignacao"
          placeholder="Ex: PST-2026-009 • Agência Talatona" class="w-full" />
      </div>

      <div class="grid-2col">
        <div class="form-group">
          <div class="label-with-badge">
            <label for="drawerNif">NIF</label>
            @if (nifValido) {
            <span class="valid-nif-badge">✓ NIF válido</span>
            }
          </div>
          <input id="drawerNif" type="text" pInputText formControlName="clienteNif" placeholder="Ex: 5417082910"
            class="w-full" />
        </div>

        <div class="form-group">
          <label for="drawerEmail">Email</label>
          <input id="drawerEmail" type="email" pInputText formControlName="clienteEmail"
            placeholder="Ex: faturacao@cliente.ao" class="w-full" />
        </div>
      </div>

      <p class="section-hint">
        <i class="fas fa-info-circle"></i> O PDF oficial e o recibo serão encaminhados para este email.
      </p>
    </section>

    <!-- SECÇÃO 2: SERVIÇOS & TRIBUTAÇÃO -->
    <section class="form-section">
      <div class="section-header">
        <h3>SERVIÇOS &amp; TRIBUTAÇÃO</h3>
        <span class="counter-badge">{{ lines.length }} {{ lines.length === 1 ? 'item' : 'itens' }}</span>
      </div>

      <div formArrayName="lines" class="lines-container">
        @for (line of lines.controls; track $index) {
        <div [formGroupName]="$index" class="line-card">
          <div class="line-header">
            <span class="line-index">Item #{{ $index + 1 }}</span>
            @if (lines.length > 1) {
            <button type="button" class="btn-icon-danger" (click)="removerLinha($index)" title="Remover linha">
              <i class="fas fa-trash-can"></i>
            </button>
            }
          </div>

          <div class="form-group">
            <label>Serviço / Artigo *</label>
            <p-select formControlName="idProduct" [options]="produtos" optionLabel="descricao" optionValue="id"
              placeholder="Selecione o serviço" [filter]="true" appendTo="body" [style]="{ width: '100%' }"
              (onChange)="onProdutoSelecionado($index, $event.value)" />
          </div>

          <div class="line-grid-row">
            <div class="form-group col-qty">
              <label>Qtd *</label>
              <p-inputNumber formControlName="quantity" [min]="0.01" [maxFractionDigits]="2" class="w-full" />
            </div>

            <div class="form-group col-price">
              <label>Preço Unit. (Kz) *</label>
              <p-inputNumber formControlName="unitPrice" [min]="0" mode="decimal" [minFractionDigits]="2"
                [maxFractionDigits]="2" class="w-full" />
            </div>

            <div class="form-group col-tax">
              <label>Imposto *</label>
              <p-select formControlName="idTaxCode" [options]="taxCodes" optionLabel="description" optionValue="id"
                appendTo="body" [style]="{ width: '100%' }" />
            </div>
          </div>

          <!-- Isenção se taxa 0% -->
          @if (getTaxPercentage(line.get('idTaxCode')?.value) === 0) {
          <div class="form-group exemption-alert">
            <label>Motivo de Isenção (AGT) *</label>
            <p-select formControlName="idTaxExemptionCode" [options]="isencoes" optionLabel="descricao" optionValue="id"
              placeholder="Selecione o motivo legal" appendTo="body" [style]="{ width: '100%' }" />
          </div>
          }

          <div class="line-subtotal">
            <span>Subtotal:</span>
            <strong>{{ calcularSubtotalLinha($index) | number: '1.2-2' }} Kz</strong>
          </div>
        </div>
        }
      </div>

      <button type="button" class="btn-add-line" (click)="adicionarLinha()">
        <i class="fas fa-plus"></i> Adicionar serviço
      </button>

      <!-- Totais Calculados -->
      <div class="totals-summary-card">
        <div class="total-row">
          <span>Subtotal:</span>
          <strong>{{ subtotalGeral | number: '1.2-2' }} Kz</strong>
        </div>
        <div class="total-row">
          <span>IVA:</span>
          <strong>{{ impostoGeral | number: '1.2-2' }} Kz</strong>
        </div>
        <div class="total-row">
          <span>Retenção (0%):</span>
          <strong>0,00 Kz</strong>
        </div>
        <div class="total-divider"></div>
        <div class="total-row total-highlight">
          <div class="total-label-wrap">
            <span class="total-main-label">Total</span>
            <small class="currency-label">Moeda: Kwanza Angolano (AOA)</small>
          </div>
          <strong class="total-main-val">{{ totalGeral | number: '1.2-2' }} Kz</strong>
        </div>
      </div>
    </section>

    <!-- SECÇÃO 3: FLUXO & FILA -->
    <section class="form-section dispatch-section">
      <div class="section-header">
        <h3>FLUXO &amp; FILA</h3>
      </div>

      <div class="dispatch-info-card">
        <div class="info-icon">
          <i class="fas fa-shield-halved"></i>
        </div>
        <div class="info-text">
          <h4>Como funciona o envio</h4>
          <p>Fluxo, fila, envio, PDF, selo fiscal e QR code.</p>
          <small class="text-muted">Nota: Em "Submetida" não envia ficheiro nem referência externa.</small>
        </div>
      </div>

      <div class="checkbox-wrapper">
        <p-checkbox formControlName="enviarAposValidacao" [binary]="true" inputId="enviarAposVal" />
        <label for="enviarAposVal">Enviar automaticamente após validação da AGT</label>
      </div>
    </section>
  </form>

  <ng-template #footer>
    <div class="drawer-footer-actions">
      <button type="button" class="btn-web-secondary" (click)="fechar()" [disabled]="saving || submitting">
        Cancelar
      </button>

      <button type="button" class="btn-web-secondary btn-draft" (click)="salvar(false)"
        [disabled]="saving || submitting">
        @if (saving) {
        <i class="fas fa-spinner fa-spin"></i> A guardar...
        } @else {
        Guardar Rascunho
        }
      </button>

      <button type="button" class="btn-web-primary" (click)="salvar(true)" [disabled]="saving || submitting">
        @if (submitting) {
        <i class="fas fa-spinner fa-spin"></i> A submeter...
        } @else {
        <i class="fas fa-paper-plane"></i> Guardar &amp; Submeter à AGT
        }
      </button>
    </div>
  </ng-template>
</p-drawer>